import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import AsyncButton from '../../../../components/AsyncButton/index';
import { appConfig } from '../../../../configureApp';

const WizardNavigationButtons = ({
  onBack,
  onNext,
  onSave,
  canMoveNext,
  listLength,
  submitted,
  loading,
  saveButtonId,
  showSpinnerForElement,
  handleKeyDown,
  intl,
  hasFormChanges,
  nextButtonRef,
}) => {

  if (appConfig.reactAppEnv === 'tugo') {
    // Tugo-specific layout: Back on left, Save and Next on right
    return (
      <div className="row justify-content-between">
        <div className="col-12 col-sm-auto">
          <button
            className="base-button regular-button"
            onClick={onBack}
            onKeyDown={handleKeyDown}
            type="button"
          >
            {intl.formatMessage({ id: 'fastCover.button.back' })}
          </button>
        </div>
        <div className="col-12 col-sm-auto">
          <div className="row">
            <div className="col-12 col-sm-auto">
              {!submitted && (
                <AsyncButton
                  id={saveButtonId}
                  className="base-button outline-button"
                  loading={loading}
                  spinner={showSpinnerForElement && showSpinnerForElement(saveButtonId)}
                  onClick={onSave}
                  onKeyDown={handleKeyDown}
                  disabled={!hasFormChanges}
                >
                  {intl.formatMessage({ id: 'fastCover.button.save' })}
                </AsyncButton>
              )}
            </div>
            <div className="col-12 col-sm-auto">
              <Button
                onClick={onNext}
                onKeyDown={handleKeyDown}
                innerRef={nextButtonRef}
                className="base-button primary-button"
                disabled={submitted ? false : !canMoveNext || !listLength}
              >
                {intl.formatMessage({ id: 'fastCover.button.next' })}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Original layout for other clients: Back and Next on left, Save on right
  return (
    <div className="row justify-content-between">
      <div className="col-12 col-sm-auto">
        <div className="row">
          <div className="col-12 col-sm-auto">
            <button
              className={"base-button back-button"}
              onClick={onBack}
              onKeyDown={handleKeyDown}
              type="button"
            >
              {intl.formatMessage({ id: 'fastCover.button.back' })}
            </button>
          </div>
          <div className="col-12 col-sm-auto">
            <Button
              onClick={onNext}
              onKeyDown={handleKeyDown}
              innerRef={nextButtonRef}
              disabled={submitted ? false : !canMoveNext || !listLength}
            >
              {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
            </Button>
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-auto">
        {!submitted && (
          <AsyncButton
            id={saveButtonId}
            className="btn-outline"
            loading={loading}
            spinner={showSpinnerForElement && showSpinnerForElement(saveButtonId)}
            onClick={onSave}
            onKeyDown={handleKeyDown}
            disabled={!hasFormChanges}
          >
            {intl.formatMessage({ id: 'fastCover.button.save' })}
          </AsyncButton>
        )}
      </div>
    </div>
  );
};

WizardNavigationButtons.propTypes = {
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  canMoveNext: PropTypes.bool,
  listLength: PropTypes.number,
  submitted: PropTypes.bool,
  loading: PropTypes.bool,
  saveButtonId: PropTypes.string,
  showSpinnerForElement: PropTypes.func,
  handleKeyDown: PropTypes.func,
  intl: PropTypes.object.isRequired,
  hasFormChanges: PropTypes.bool,
  nextButtonRef: PropTypes.func,
};

export default WizardNavigationButtons;




// WEBPACK FOOTER //
// ./app/containers/FastCover/components/WizardNavigationButtons/index.js